import { render, staticRenderFns } from "./personalSettings.vue?vue&type=template&id=2fa5f2cc&scoped=true&"
import script from "./personalSettings.vue?vue&type=script&lang=js&"
export * from "./personalSettings.vue?vue&type=script&lang=js&"
import style0 from "./personalSettings.vue?vue&type=style&index=0&id=2fa5f2cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5f2cc",
  null
  
)

export default component.exports